import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH
} from "@common/constants/passwordLength";

export const isPasswordCorrectLength = password =>
  password.length >= PASSWORD_MIN_LENGTH &&
  password.length <= PASSWORD_MAX_LENGTH;
